export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrows-in-6d982e1072500c1ba8f8fb3c1350342e.svg";